"use strict";
var moment = require("moment");
var constants_1 = require("./constants");
function dateInRangeValidator(maxDate, minDate) {
    if (maxDate === void 0) { maxDate = null; }
    if (minDate === void 0) { minDate = null; }
    return function (control) {
        var value = control.value;
        if (value && value !== '') {
            var dateValue = moment(value, constants_1.Constants.DATE_PARSE_FORMAT);
            if (!dateValue.isValid()) {
                return { 'invalid': value };
            }
            // target date must be on or before max date
            if (maxDate) {
                var maxValue = moment(maxDate, constants_1.Constants.DATE_PARSE_FORMAT);
                if (maxValue.isValid() && dateValue.startOf('day').isAfter(maxValue.startOf('day'))) {
                    return { 'afterMax': value };
                }
            }
            // target date must be on or after min date
            if (minDate) {
                var minValue = moment(minDate, constants_1.Constants.DATE_PARSE_FORMAT);
                if (minValue.isValid() && dateValue.startOf('day').isBefore(minValue.startOf('day'))) {
                    return { 'beforeMin': value };
                }
            }
        }
        return null;
    };
}
exports.dateInRangeValidator = dateInRangeValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/date-in-range.validator.js